// src/contexts/AuthProvider.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useMsal } from "@azure/msal-react";
import config from "../configs/config";
import apiService from "../services/apiService";

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const { instance } = useMsal();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
      setIsAuthenticated(true);
    }
  }, []);

  const login = (userData) => {
    setIsAuthenticated(true);
    setUser(userData);
    if (userData.user && userData.user.organization) {
      localStorage.setItem(
        "organization",
        JSON.stringify(userData.user.organization)
      );
    }
    localStorage.setItem('user', JSON.stringify(userData));
  }

  const logout = async () => {
    try {
      // Call logout API if needed
      await apiService.logout();
    } catch (error) {
      console.error('Logout API error:', error);
    } finally {
      // Clear all localStorage
      localStorage.clear();

      // Clear sessionStorage if any
      sessionStorage.clear();

      // Clear all cookies
      document.cookie.split(";").forEach(function (c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });

      // Clear state
      setUser(null);
      setIsAuthenticated(false);

      // Clear API service auth
      apiService.clearAuth();

      // Microsoft logout redirect
      try {
        await instance.logoutRedirect({
          postLogoutRedirectUri: config.POSTREDIRECT_URL
        });
      } catch (msalError) {
        console.error('MSAL logout error:', msalError);
        // Fallback redirect if MSAL logout fails
        window.location.href = config.POSTREDIRECT_URL;
      }
    }
  };

  return (
    <AuthContext.Provider value={{
      setUser,
      user,
      login,
      logout,
      isAuthenticated
    }}>
      {children}
    </AuthContext.Provider>
  );
}